export const productName = 'MEGAPACK ENERGÍA NUCLEAR LISTO';
export const productShortName = 'Megapack Energía Nuclear Listo';
export const productImage = 'https://cdn.magicpatterns.com/uploads/bXbpDo31FD5sVUK4GRKQ44/MOCKUP_7.07.54_p._m..png';

export const checkoutUrl = 'https://megapack-energia-nuclear-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos de la Energía Nuclear',
  'Tomo 2 — Radiactividad y Radiación Ionizante',
  'Tomo 3 — Fisión Nuclear y Producción de Energía',
  'Tomo 4 — Reactores y Centrales Nucleares',
  'Tomo 5 — Seguridad Nuclear y Protección Radiológica',
  'Tomo 6 — Combustible Nuclear y Gestión de Residuos Radiactivos',
  'Tomo 7 — Aplicaciones de la Tecnología Nuclear en Medicina, Industria, Agricultura y Ciencia',
  'Tomo 8 — Energía Nuclear, Ambiente y Desarrollo Sostenible',
  'Tomo 9 — Enseñanza de la Energía Nuclear: Estrategias, Actividades y Propuestas para el Aula',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones',
  'Bono 4 — 100 Proyectos, Debates y Propuestas',
  'Bono 5 — Guía de Conceptos, Glosario y Mitos',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de actividades sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de energía nuclear complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la energía nuclear',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
